<div class="campaign-quicksearch--wrapper campaign-quicksearch--has-no-filter-btn">
  <mat-form-field class="col__ no-label mb-0"
                  [ngClass]="{'loading': loading}">
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-magnifying-glass"
              class="color--gray--007"
              *ngIf="!loading"></mat-icon>
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-spinner"
              class="color--gray--007 fa-spin"
              *ngIf="loading"></mat-icon>
    <input matInput
           placeholder="Search campaigns"
           name="search-campaigns"
           [formControl]="filterInput"
           autocomplete="off"
           appAutofocus
           (keydown.arrowdown)="focusResults()">
  </mat-form-field>
  <section (keydown)="onResultsListKeydown($event)"
           tabindex="0">
    <cdk-virtual-scroll-viewport class="campaign-quicksearch__results"
                                 itemSize="48"
                                 #scrollContainer
                                 minBufferPx="200"
                                 maxBufferPx="400"
                                 style="height: 250px;">
      <ng-container *cdkVirtualFor="let result of results">
        <app-list-item [item]="result"
                       class="campaign-result"
                       (click)="itemClicked(result)">
          <span class="campaign-result__name truncate">
            {{result.name}}
          </span>
        </app-list-item>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </section>
</div>
